'use client';
import { ListboxOptionTextContainer } from '../listbox/listbox-option-text-container.component.js';

const ComboboxOptionTextContainer = ListboxOptionTextContainer;

export { ComboboxOptionTextContainer };
